import { StringBase } from '../StringBase';
import { ArrayBase } from '../ArrayBase';
import { Base } from '../Base';

export class ContentVertical extends Base {
  precreated = null;
  custom = null;

  isValid() {
    return (
      (this.custom && this.custom.length > 0) || (this.precreated && this.precreated.length > 0)
    );
  }

  static count(target) {
    let len = 0;
    if (target && target.custom) {
      len = StringBase.count(target.custom);
    }

    if (target && target.precreated) {
      len += ArrayBase.count(target.precreated);
    }
    return len;
  }
}
